
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from 'dayjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import timezone from 'dayjs/plugin/timezone';
// eslint-disable-next-line import/no-extraneous-dependencies
import duration from 'dayjs/plugin/duration';

dayjs.extend(timezone);
dayjs.extend(duration);

export default {
  data() {
    return {
      deadline: this.setDeadline(),
      timeValues: {
        Hours: '00',
        Minutes: '00',
        Seconds: '00',
      },
      prevValues: {
        Hours: '00',
        Minutes: '00',
        Seconds: '00',
      },
      flipStates: {
        Hours: false,
        Minutes: false,
        Seconds: false,
      },
      interval: null,
    };
  },
  methods: {
    setDeadline() {
      return dayjs().tz('America/New_York').endOf('day');
    },
    updateClock() {
      const now = dayjs().tz('America/New_York');
      const diff = this.deadline.diff(now);

      if (diff <= 0) {
        clearInterval(this.interval);
        this.$emit('complete');
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor((totalSeconds / 3600) % 24);
      const minutes = Math.floor((totalSeconds / 60) % 60);
      const seconds = totalSeconds % 60;

      this.updateValues('Hours', hours);
      this.updateValues('Minutes', minutes);
      this.updateValues('Seconds', seconds);
    },
    updateValues(key, newValue) {
      const formattedValue = String(newValue).padStart(2, '0');

      if (this.timeValues[key] !== formattedValue) {
        this.prevValues[key] = this.timeValues[key];
        this.timeValues[key] = formattedValue;
        this.flipStates[key] = true;

        setTimeout(() => {
          this.flipStates[key] = false;
        }, 500);
      } else {
        this.flipStates[key] = false;
      }
    },
  },
  mounted() {
    this.updateClock();
    this.interval = setInterval(this.updateClock, 500);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
